import React from "react";
import Modal from "../shared/Modal";
import "../shared/customModal.css";
import useGetAccountById, {
  accountCredentialInterface,
  accountInterface,
  BaseLivlyApiResponse,
} from "./hooks/useGetAccountById";
import { Spinner } from "components/shared/Spinner";
import { SiteSystemType } from "api/ApiClient";
import usePatchAccount from "./hooks/usePatchAccount";
import { useSnackbar } from "notistack";
import { Button } from "components/ui/button";

const EditAdminAccount = ({
  open,
  onClose,
  accountId,
}: {
  open: boolean;
  onClose: () => void;
  accountId: string;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading } = useGetAccountById(accountId);
  const updateAccount = usePatchAccount(accountId);
  const [info, setInfo] = React.useState<accountCredentialInterface | null>(
    null,
  );
  React.useEffect(() => {
    if (data?.accountCredentials) {
      setInfo(data.accountCredentials as accountCredentialInterface);
    }
  }, [data]);

  const onSubmit = () => {
    if (info !== null) {
      updateAccount.mutateAsync(info, {
        onSuccess() {
          enqueueSnackbar(
            <p style={{ fontSize: "12px", padding: 0, margin: 0 }}>
              Account updated successfully
            </p>,
            { variant: "success" },
          );
          handleClose();
        },
        onError(err: any) {
          let errorMessage = "Error updating account";
          try {
            if (err?.response) {
              const data =
                typeof err.response === "string"
                  ? JSON.parse(err.response)
                  : err.response;
              if (data?.errors?.length) {
                errorMessage = data.errors
                  .map((x: any) => x.message)
                  .join(", ");
              } else if (data?.message) {
                errorMessage = data.message;
              }
            } else if (err?.message) {
              errorMessage = err.message;
            }
          } catch {
            // ignore parse
          }
          enqueueSnackbar(
            <p style={{ fontSize: "12px", padding: 0, margin: 0 }}>
              {errorMessage}
            </p>,
            { variant: "error" },
          );
        },
      });
    }
  };

  const handleClose = () => {
    onClose();
    setInfo(null);
  };
  return (
    <Modal
      show={open}
      onHide={handleClose}
      aria-labelledby="edit-account"
      aria-describedby="edit-account-by-Id"
    >
      <Modal.Header closeButton>
        <Modal.Title id="EditModalHeader">
          Edit Account: {accountId}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ width: "50vw" }}>
        {isLoading ? (
          <div
            style={{
              marginBottom: "50px",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <>
            <div className="form-group">
              <label htmlFor="username">User Name *</label>
              <input
                className="form-control"
                name="username"
                placeholder="username"
                value={info?.username}
                //@ts-ignore
                onChange={(e) => setInfo({ ...info, username: e.target.value })}
              />
            </div>
            {/* For Dormakaba accounts only the name field should be visible */}
            {data?.systemType !== SiteSystemType.DormaKaba && (
              <>
                <div className="form-group">
                  <label htmlFor="password">Password *</label>
                  <input
                    className="form-control"
                    name="password"
                    type="password"
                    placeholder="password"
                    value={info?.password}
                    onChange={(e) =>
                      //@ts-ignore
                      setInfo({ ...info, password: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="clientId">ClientId *</label>
                  <input
                    className="form-control"
                    name="clientId"
                    placeholder="Client Id"
                    value={info?.clientId}
                    onChange={(e) =>
                      //@ts-ignore
                      setInfo({ ...info, clientId: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="clientSecret">Client Secret *</label>
                  <input
                    className="form-control"
                    name="clientSecret"
                    type="password"
                    placeholder="Client Secret"
                    value={info?.clientSecret}
                    onChange={(e) =>
                      //@ts-ignore
                      setInfo({ ...info, clientSecret: e.target.value })
                    }
                  />
                </div>
                {data?.systemType === SiteSystemType.Brivo && (
                  <>
                    {" "}
                    <div className="form-group">
                      <label htmlFor="clientId">ClientId 2 *</label>
                      <input
                        className="form-control"
                        name="clientId"
                        placeholder="Client Id"
                        value={info?.clientId2}
                        onChange={(e) =>
                          //@ts-ignore
                          setInfo({ ...info, clientId2: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="clientSecret">Client Secret 2 *</label>
                      <input
                        className="form-control"
                        name="clientSecret"
                        type="password"
                        placeholder="Client Secret"
                        value={info?.clientSecret2}
                        onChange={(e) =>
                          //@ts-ignore
                          setInfo({ ...info, clientSecret2: e.target.value })
                        }
                      />
                    </div>
                  </>
                )}

                <div className="form-group">
                  <label htmlFor="accessToken"> Access Token *</label>
                  <input
                    className="form-control"
                    name="accessToken"
                    placeholder=" Access Token"
                    value={info?.accessToken}
                    onChange={(e) =>
                      //@ts-ignore
                      setInfo({ ...info, accessToken: e.target.value })
                    }
                  />
                </div>
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onSubmit()}
          disabled={updateAccount.isPending}
          type="button"
        >
          Save
        </Button>
        <Modal.Dismiss disabled={updateAccount.isPending}>Close</Modal.Dismiss>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAdminAccount;
